import { useBooleanState } from 'hooks/useBooleanState';
import { useCallback, useRef } from 'react';
import { useEvent } from 'react-use';
import { Button, Icons } from 'ui-kit';
import styles from './ScrollToTop.module.scss';

export function ScrollToTop() {
  const [isShown, show, hide] = useBooleanState(false);
  const prevScroll = useRef(0);

  useEvent('scroll', () => {
    if (window.scrollY < prevScroll.current && !isShown) {
      show();
    }
    if ((window.scrollY > prevScroll.current && isShown) || !window.scrollY) {
      hide();
    }
    prevScroll.current = window.scrollY;
  });

  const scrollTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!isShown) return null;

  return (
    <Button
      square
      variant="button"
      className={styles.scrollToTop}
      onClick={scrollTop}
    >
      <Icons.ScrollUp />
    </Button>
  );
}
